import {Oui} from './Oui';
export class DocPayants {

	public oui: Oui;

	public non: string;

	constructor() { 
		 		this.oui = new Oui();
		this.non = '';
 
	}
}
